/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import animateIn from "animations/animate-in/animate-in";
import button from "components/buttons/buttons";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import cmsContent from "components/cms-content/cms-content";
import heroSlider from "imComponents/hero-slider/hero-slider";
import accordion from "imComponents/accordion/accordion";
import titleBox from "components/title-box/title-box";
import modal from "imComponents/modal/modal";
import textImgVar from "imComponents/text-img-var/text-img-var";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import customQuote from "components/custom-quote/custom-quote";
import boxImage from "components/box-image/box-image";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";
import colTitleText from "components/col-title-text/col-title-text";
import cardNews from "components/cards/card-news";
import sliderNews from "components/slider-news/slider-news";
import menu from "components/menu/menu";
import footer from "components/footer/footer";
import heroImage from "imComponents/hero-image/hero-image";
import textIframe from "components/text-iframe/text-iframe";
import contactForm from "components/contact-form/contact-form";

//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector("body.wp-admin")) {
        initHeader();
        heroSlider();
    }
    accordion();
    animateIn();
    modal();
    carouselGallery();
    sliderNews();
}
if (document.querySelector("body.wp-admin")) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction("render_block_preview", initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
